// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W5jE","placeholdersHeader":"styles_placeholdersHeader__VOJDy","editorStyle":"styles_editorStyle__2dPrE","placeholdersBox":"styles_placeholdersBox__cPaX7"};